import fetchServer from "../helpers/api/fetchServer";

export const getAudiences = async () => {
  const method = "GET";
  const urlAPI = "/api/audiences";
  return await fetchServer({ method, urlAPI });
};

export const getAudiencesByAdAccount = async (adAccountId) => {
  const method = "GET";
  const urlAPI = `/api/audiences?adAccount=${adAccountId}`;
  return await fetchServer({ method, urlAPI });
};

export const getAudience = async (id) => {
  const method = "GET";
  const urlAPI = `/api/audiences/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const updateAudience = async ({ id, accountIds }) => {
  const method = "PATCH";
  const urlAPI = `/api/audiences/${id}`;
  const body = { accountIds };
  return await fetchServer({ method, urlAPI, body });
};

